import icProgramPlay from "@/assets/images/user/icProgramPlay.svg";
import programPlayCont1Img1 from "@/assets/images/user/programPlayCont1Img1.jpg";
import programPlayCont1Img2 from "@/assets/images/user/programPlayCont1Img2.jpg";
import programPlayCont1Img3 from "@/assets/images/user/programPlayCont1Img3.jpg";
import programPlayCont1Img4 from "@/assets/images/user/programPlayCont1Img4.jpg";
import programPlayCont1Img5 from "@/assets/images/user/programPlayCont1Img5.jpg";
import programPlayCont1Img6 from "@/assets/images/user/programPlayCont1Img6.jpg";
import programPlayCont1Img7 from "@/assets/images/user/programPlayCont1Img7.jpg";
import programPlayCont1Img8 from "@/assets/images/user/programPlayCont1Img8.jpg";
import programPlayCont1Img9 from "@/assets/images/user/programPlayCont1Img9.jpg";
import programPlayCont1Img10 from "@/assets/images/user/programPlayCont1Img10.jpg";
import programPlayCont1Img11 from "@/assets/images/user/programPlayCont1Img11.jpg";
import programPlayCont1Img12 from "@/assets/images/user/programPlayCont1Img12.jpg";
import programPlayCont1Img13 from "@/assets/images/user/programPlayCont1Img13.jpg";
import programPlayCont2Img1 from "@/assets/images/user/programPlayCont2Img1.jpg";
import programPlayCont2Img2 from "@/assets/images/user/programPlayCont2Img2.jpg";
import programPlayCont3Img1 from "@/assets/images/user/programPlayCont3Img1.jpg";
import programPlayCont4Img1 from "@/assets/images/user/programPlayCont4Img1.jpg";
import programPlayCont4Img2 from "@/assets/images/user/programPlayCont4Img2.jpg";
import programPlayCont5Img1 from "@/assets/images/user/programPlayCont5Img1.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

interface Booth {
    title: string;
    img: string;
    list: { title: string; content: string | React.ReactNode; positionTop?: boolean }[];
}

const boothList: Booth[] = [
    {
        title: "젠레스 존 제로",
        img: programPlayCont1Img1,
        list: [
            {
                title: "위치",
                content: "판교역 중앙광장",
            },
            {
                title: "내용",
                content: (
                    <span>
                        GXG 2025에 상륙한 <br className="md:hidden" />
                        호요버스 <br className="hidden md:block" />
                        어반 판타지 <br className="md:hidden" />
                        ARPG 젠레스 존 제로. <br />
                        뉴에리두에 오신 걸 환영합니다.
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "레드프린팅",
        img: programPlayCont1Img2,
        list: [
            {
                title: "위치",
                content: "판교역 중앙광장",
            },
            {
                title: "내용",
                content: (
                    <span>
                        나만의 디자인으로 <br />
                        다양한 커스텀 제품을 체험
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "Microsoft",
        img: programPlayCont1Img3,
        list: [
            {
                title: "위치",
                content: "판교역 중앙광장",
            },
            {
                title: "내용",
                content: (
                    <span>
                        내 손으로 직접 경험해보는 <br />
                        Microsoft Copilot + AI <br className="xl:hidden" />
                        체험 존
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "SYLO",
        img: programPlayCont1Img4,
        list: [
            {
                title: "위치",
                content: "판교역 중앙광장",
            },
            {
                title: "내용",
                content: (
                    <span>
                        신작 모바일 게임 플레이 체험 및 <br />
                        리워드 미션 이벤트
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "클라우디드 레오파드 엔터테인먼트코리아",
        img: programPlayCont1Img5,
        list: [
            {
                title: "위치",
                content: "판교역 중앙광장",
            },
            {
                title: "내용",
                content: (
                    <span>
                        궤적 시리즈 첫 작품의 풀 리메이크
                        <br />
                        「하늘의 궤적 the 1st」타이틀 체험존
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "슈퍼셀 타운",
        img: programPlayCont1Img6,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        GXG 2025에 슈퍼셀 타운이 <br className="md:hidden" />
                        등장! <br />
                        모두가 사랑하는 인기 게임 <br className="md:hidden" />
                        클래시 <br className="hidden md:block" />
                        오브 클랜, 클래시 로얄, <br className="md:hidden" />
                        브롤스타즈가 전부 한 자리에?
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "스마일게이트(게임 접근성)",
        img: programPlayCont1Img7,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        게임 접근성 보조기기 <br />
                        전시 및 체험
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "굴뚝강아지 (빨간포션)",
        img: programPlayCont1Img8,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        게임 컨셉 에너지드링크 <br />
                        &apos;빨간포션&apos; 체험 부스
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "성남게임힐링센터",
        img: programPlayCont1Img9,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        게임 습관 체크하고, <br />
                        나만의 굿즈와 부적도 득템
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "창조공작소",
        img: programPlayCont1Img10,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        성우 더빙을 직접 체험할 수 <br />
                        있는 게임사운드 스튜디오
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "오렌지커뮤니케이션즈",
        img: programPlayCont1Img11,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        오디오북 제작을 AI 플랫폼에서?! <br />
                        직접 만드는 오디오북 컨텐츠
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "바다",
        img: programPlayCont1Img12,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        사운드 라이브러리부터 <br />
                        AI 사운드 프로덕션까지! <br />
                        한 곳에서 만나는 <br />
                        게임 사운드의 모든 것
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "매직빈게임즈",
        img: programPlayCont1Img13,
        list: [
            {
                title: "위치",
                content: "판교역 북측광장 A",
            },
            {
                title: "내용",
                content: (
                    <span>
                        누구나 즐기는 보드게임 체험과 <br />
                        즐거운 미니게임 대회
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
];

const boothList2 = [
    {
        title: "한림사",
        img: programPlayCont2Img1,
        list: [
            {
                title: "내용",
                content: (
                    <span>
                        게임 아트, 일러스트, <br className="xl:hidden" />
                        애니메이션 전문 서적을 <br className="xl:hidden" />
                        만나보세요
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "GXG Goods for Good",
        img: programPlayCont2Img2,
        list: [
            {
                title: "내용",
                content: (
                    <span>
                        오직 GXG에서만 특별한 <br className="xl:hidden" />
                        가격으로 만나는 게임 굿즈! <br className="xl:hidden" />
                        구매하면 자동으로 <br className="xl:hidden" />
                        기부까지! <br />
                        ※ 모든 수익금은 성남시한마음복지관에 <br className="xl:hidden" />
                        기부됩니다.
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
];

const boothList3 = [
    {
        title: "신구대학교 게임콘텐츠과",
        img: programPlayCont4Img1,
        list: [
            {
                title: "운영시간",
                content: "13:00 ~ 19:00 (양일 모두 운영)",
            },
            {
                title: "내용",
                content: (
                    <span>
                        창의와 열정이 빚어낸 <br className="xl:hidden" />
                        신구대 게임콘텐츠과 <br className="xl:hidden" />
                        학생들의 최신 게임 작품 전시
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
    {
        title: "동서울대학교 메타버스게임애니메이션과",
        img: programPlayCont4Img2,
        list: [
            {
                title: "운영시간",
                content: "13:00 ~ 19:00 (양일 모두 운영)",
            },
            {
                title: "내용",
                content: (
                    <span>
                        WEB 3.0의 인공지능과 <br className="xl:hidden" />
                        블록체인을 기반으로 <br className="xl:hidden" />
                        메타버스 게임 네트워크에서 <br />
                        새로운 가치를 창출하는 <br className="xl:hidden" />
                        메타버스 게임 체험 및 전시
                    </span>
                ),
                positionTop: true,
            },
        ],
    },
];

const programList = [
    {
        title: "브랜드 체험존",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 21:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장 / 북측광장 A
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            GXG 2025와 함께 하는 다양한 브랜드를 체험해보세요!
                        </p>
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        <p className="text-[20px] font-['GongGothicMedium'] md:text-[28px]">부스 소개</p>
                        <ul className="flex flex-col gap-[20px] md:flex-row md:gap-x-[16px] md:gap-y-[20px] md:flex-wrap">
                            {boothList.map((booth, i) => (
                                <li
                                    key={`booth_${i}`}
                                    className="w-full flex flex-col md:w-[calc(50%-8px)] xl:w-[calc(33.333%-10.666px)]"
                                >
                                    <img src={booth.img} alt={booth.title} className="w-full" />
                                    <div className="flex-1 bg-[#F1F4F9] p-[20px_12px] flex flex-col gap-[16px] md:p-[20px] md:gap-[24px]">
                                        <div className="flex gap-[8px] items-center md:gap-[12px]">
                                            <p className="text-center text-white font-['GongGothicMedium'] text-[14px] size-[28px] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] rounded-full leading-[28px] md:text-[20px] md:size-[40px] md:leading-[41px]">
                                                {i < 9 ? `0${i + 1}` : i + 1}
                                            </p>
                                            <p className="flex-1 text-[18px] font-['GongGothicMedium'] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent md:text-[24px]">
                                                {booth.title}
                                            </p>
                                        </div>
                                        <ul className="flex flex-col gap-[8px] md:gap-[16px]">
                                            {booth.list.map((item, j) => (
                                                <li
                                                    key={`booth_${i}_${j}`}
                                                    className={`flex${item.positionTop ? "" : " items-center"}`}
                                                >
                                                    <p className="w-[84px] font-['GongGothicMedium'] relative after:absolute after:top-[5px] after:left-0 after:content-[''] after:size-[8px] after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:rounded-full pl-[16px] md:w-[108px] md:text-[20px] md:pl-[20px] md:after:top-[9px]">
                                                        {item.title}
                                                    </p>
                                                    <p className="flex-1 font-['GongGothicLight'] md:text-[18px]">
                                                        {item.content}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </li>
            </ul>
        ),
    },
    {
        title: "GXG 마켓",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 21:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            다양한 게임사 굿즈부터 게임 아트, <br className="md:hidden" />
                            일러스트북 까지! <br />
                            GXG 마켓에서 축제를 즐기는 <br className="md:hidden" />
                            또다른 재미를 느껴보세요!
                        </p>
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        <p className="text-[20px] font-['GongGothicMedium'] md:text-[28px]">부스 소개</p>
                        <ul className="flex flex-col gap-[20px] md:flex-row md:gap-x-[16px] md:gap-y-[20px] md:flex-wrap xl:flex-col">
                            {boothList2.map((booth, i) => (
                                <li
                                    key={`booth_${i}`}
                                    className="w-full flex flex-col md:w-[calc(50%-8px)] xl:w-full xl:flex xl:flex-row"
                                >
                                    <img src={booth.img} alt={booth.title} className="w-full xl:w-[340px]" />
                                    <div className="flex-1 bg-[#F1F4F9] p-[20px_12px] flex flex-col gap-[16px] md:p-[20px] md:gap-[24px] xl:flex-1 xl:p-[20px_40px] xl:justify-center">
                                        <div className="flex gap-[8px] items-center md:gap-[12px]">
                                            <p className="text-center text-white font-['GongGothicMedium'] text-[14px] size-[28px] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] rounded-full leading-[28px] md:text-[20px] md:size-[40px] md:leading-[41px]">
                                                {i < 9 ? `0${i + 1}` : i + 1}
                                            </p>
                                            <p className="text-[18px] font-['GongGothicMedium'] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent md:text-[24px]">
                                                {booth.title}
                                            </p>
                                        </div>
                                        <ul className="flex flex-col gap-[8px] md:gap-[16 px]">
                                            {booth.list.map((item, j) => (
                                                <li
                                                    key={`booth_${i}_${j}`}
                                                    className={`flex${item.positionTop ? "" : " items-center"}`}
                                                >
                                                    <p className="text-[16px] w-[84px] font-['GongGothicMedium'] relative after:absolute after:top-[5px] after:left-0 after:content-[''] after:size-[8px] after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:rounded-full pl-[16px] md:w-[108px] md:text-[20px] md:pl-[20px] md:after:top-[9px]">
                                                        {item.title}
                                                    </p>
                                                    <p className="text-[16px] flex-1 font-['GongGothicLight'] md:text-[18px]">
                                                        {item.content}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </li>
            </ul>
        ),
    },
    {
        title: "Cool Station with 동아오츠카",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금)~9/20(토), 13:00 ~ 21:00 <br />※ 소진 시 운영이 조기 종료될 수 있습니다.
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            판교역 북측광장 B
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            GXG 2025를 에너지 넘치게 즐기는 <br className="md:hidden" />
                            더욱 특별한 방법! <br />
                            동아오츠카 음료와 함께 잠시 <br className="md:hidden" />
                            쉬어 가세요!
                        </p>
                    </li>
                </ul>
                <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programPlayCont3Img1} alt="이미지" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: "GXG 캠퍼스 아케이드 ",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 19:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        테크원타워 2F
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            게임 관련 학과 학생들이 제작한 <br className="md:hidden" />
                            게임을 체험해보세요!
                        </p>
                    </div>
                    <div className="flex flex-col gap-[20px]">
                        <p className="text-[20px] font-['GongGothicMedium'] md:text-[28px]">부스 소개</p>
                        <ul className="flex flex-col gap-[20px] md:flex-row md:gap-x-[16px] md:gap-y-[20px] md:flex-wrap xl:flex-col">
                            {boothList3.map((booth, i) => (
                                <li
                                    key={`booth_${i}`}
                                    className="w-full flex flex-col md:w-[calc(50%-8px)] xl:w-full xl:flex xl:flex-row"
                                >
                                    <img src={booth.img} alt={booth.title} className="w-full xl:w-[340px]" />
                                    <div className="flex-1 bg-[#F1F4F9] p-[20px_12px] flex flex-col gap-[16px] md:p-[20px] md:gap-[24px] xl:flex-1 xl:p-[20px_40px] xl:justify-center">
                                        <div className="flex gap-[8px] items-center md:gap-[12px]">
                                            <p className="text-center text-white font-['GongGothicMedium'] text-[14px] size-[28px] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] rounded-full leading-[28px] md:text-[20px] md:size-[40px] md:leading-[41px]">
                                                {i < 9 ? `0${i + 1}` : i + 1}
                                            </p>
                                            <p className="flex-1 text-[18px] font-['GongGothicMedium'] bg-gradient-to-r from-[#00A8A0] to-[#00B8BB] bg-clip-text text-transparent md:text-[24px]">
                                                {booth.title}
                                            </p>
                                        </div>
                                        <ul className="flex flex-col gap-[8px] md:gap-[16 px]">
                                            {booth.list.map((item, j) => (
                                                <li
                                                    key={`booth_${i}_${j}`}
                                                    className={`flex${item.positionTop ? "" : " items-center"}`}
                                                >
                                                    <p className="text-[16px] w-[84px] font-['GongGothicMedium'] relative after:absolute after:top-[5px] after:left-0 after:content-[''] after:size-[8px] after:bg-gradient-to-r after:from-[#00A8A0] after:to-[#00B8BB] after:rounded-full pl-[16px] md:w-[108px] md:text-[20px] md:pl-[20px] md:after:top-[9px]">
                                                        {item.title}
                                                    </p>
                                                    <p className="text-[16px] flex-1 font-['GongGothicLight'] md:text-[18px]">
                                                        {item.content}
                                                    </p>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </li>
            </ul>
        ),
    },
    {
        title: "GXG 플레이 라운지",
        background: "bg-program202502",
        img: icProgramPlay,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금)~9/20(토), 13:00 ~ 21:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            판교역 북측광장 B
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px] md:items-center">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            즐거움이 가득한 인기 콘솔 게임 <br className="md:hidden" />
                            테마파크! <br />
                            플레이 라운지에서 다양한 게임을 <br className="md:hidden" />
                            체험해보세요!
                        </p>
                    </li>
                </ul>
                <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                    <img src={programPlayCont5Img1} alt="이미지" className="w-full" />
                </div>
            </div>
        ),
    },
];

export default function Play() {
    return (
        <>
            <div className="p-[48px_0_20px] xl:pt-[60px] text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px] xl:text-right">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            />
        </>
    );
}
